import {CancelBookingCommand, RescheduleBookingCommand} from "../../domain/types";
import {V2CancelRequest, V2RescheduleRequest} from "./mapper.types";

/**
 * Zero-pads to two digits. The stored month is padded ("03", "04") on both API
 * versions, so the request matches what the booking already holds.
 */
const padToTwoDigits = (value: string | number): string => String(value).padStart(2, "0");

/**
 * Maps booking-action commands to v2 request bodies.
 *
 * v2 uses camelCase, sends every field as a string, and carries the booking
 * reference in the path rather than the body. Both actors share one body shape.
 *
 * Pure TypeScript - no React imports.
 */
export const BookingActionsMapperV2 = {
  toCancelRequest(command: CancelBookingCommand): V2CancelRequest {
    return {reason: command.reason};
  },

  toRescheduleRequest(command: RescheduleBookingCommand): V2RescheduleRequest {
    return {
      bookingYear: String(command.bookingYear),
      bookingMonth: padToTwoDigits(command.bookingMonth),
      // Day of the month is stored unpadded, so it is not padded here.
      bookingDate: String(command.bookingDate),
      timeSlot: command.timeSlot,
      reason: command.reason,
    };
  },
};
